export default {"src":"/_next/static/media/graphik.d4fc8629.svg","height":102,"width":438};